import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class AccountsService extends BaseService<Account, 'accountID', 'accounts'> {
	constructor() {
		super('accountID', 'account', 'accounts');
	}

	async addPaytrailCard() {
		const response = await axiosInstance.get(
			'app/accounts/addPaytrailCard',
		);
		return response;
	}

	async requestInvoicing(): Promise<void> {
		await axiosInstance.post('app/accounts/requestInvoicing');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new AccountsService();
